<template>
    <ion-page>
        <standard-header title="Goods In" align="middle"/>
        <ion-content>
            <ion-list>
                <ion-item lines="none">
                    <ion-label class="ion-text-wrap" v-if="hasScannedItem">
                        <h2>{{ scannedItem.name }}</h2>
                        <p>{{ scannedItem.item_number }}</p>
                    </ion-label>
                    <ion-label v-else>
                        <h2>Scan or search for item</h2>
                    </ion-label>
                    <ion-button size="medium" color="primary" @click="openItemScanner()">
                        <ion-icon slot="icon-only" :icon="barcode"/>
                    </ion-button>
                    <ion-button expand="block" color="primary" size="medium" @click="openItemPicker()">
                        <ion-icon slot="icon-only" :icon="search"/>
                    </ion-button>
                </ion-item>
                <div class="ion-padding-horizontal">
                    <ion-button v-if="hasScannedItem" expand="block" fill="outline" color="dark" @click="$refs['product'].open()">Product Card</ion-button>
                    <product-card-modal ref="product" :item="scannedItem" />
                </div>
                <ion-item lines="none">
                    <ion-label><strong>Or...</strong> This is a new item</ion-label>
                    <ion-checkbox @ionChange="setNew($event.detail.checked)" v-model="isNewItem"></ion-checkbox>
                </ion-item>
                <section :class="requiresInput?'masked':''">
                    <ion-item lines="none" v-show="isNewItem">
                        <ion-label position="stacked">Supplier</ion-label>
                        <ion-select v-model="newItem.supplier" placeholder="Choose Supplier">
                            <ion-select-option :value="supplier" v-for="supplier in suppliers" :key="supplier.id">{{ supplier.name }}</ion-select-option>
                        </ion-select>
                    </ion-item>
                    <ion-item lines="none" v-show="isNewItem">
                        <ion-label position="stacked">Name</ion-label>
                        <ion-input v-model="newItem.name" placeholder="Name or Description of Item" />
                    </ion-item>
                    <ion-item lines="none" v-show="isNewItem">
                        <ion-label position="stacked">Item Number</ion-label>
                        <ion-input v-model="newItem.item_number" placeholder="Item Number" />
                    </ion-item>
                    <ion-item lines="none" >
                        <ion-label position="stacked">Item Barcode</ion-label>
                        <ion-input v-if="isNewItem" v-model="newItem.barcode" placeholder="Item Barcode" />
                        <ion-input v-else v-model="scannedItem.barcode" placeholder="Item Barcode!!" />
                    </ion-item>
                    <div v-show="!isNewItem">
                        <ion-item lines="none">
                            <ion-label>
                                <h2>Inner Quantity</h2>
                            </ion-label>
                            {{ scannedItem.inner_qty }}
                        </ion-item>
                        <ion-item lines="none">
                            <ion-label>
                                <h2>Case Quantity</h2>
                            </ion-label>
                            {{ scannedItem.case_qty }}
                        </ion-item>
                    </div>
                    <ion-item lines="none">
                        <big-stepper v-if="isNewItem" v-model="newItem.case_qty" label="Case Quantity" size="small" />
                        <big-stepper v-else v-model="scannedItem.case_qty" label="Case Quantity" size="small" />
                    </ion-item>
                    <ion-item lines="none">
                        <big-stepper v-if="isNewItem" v-model="newItem.inner_qty" label="Inner Quantity" size="small" />
                        <big-stepper v-else v-model="scannedItem.inner_qty" label="Inner Quantity" size="small" />
                    </ion-item>
                    <ion-item lines="none">
                        <big-stepper v-if="isNewItem" v-model="newItem.case_width_cm" label="Box Width" size="small" units="cm" />
                        <big-stepper v-else v-model="scannedItem.case_width_cm" label="Box Width" size="small" units="cm" />
                    </ion-item>
                    <ion-item lines="none">
                        <big-stepper v-if="isNewItem" v-model="newItem.case_length_cm" label="Box Length" size="small" units="cm"/>
                        <big-stepper v-else v-model="scannedItem.case_length_cm" label="Box Length" size="small" units="cm" />
                    </ion-item>
                    <ion-item lines="none">
                        <big-stepper v-if="isNewItem" v-model="newItem.case_height_cm" label="Box Height" size="small" units="cm"/>
                        <big-stepper v-else v-model="scannedItem.case_height_cm" label="Box Height" size="small" units="cm" />
                    </ion-item>
                    <ion-item lines="none">
                        <big-stepper v-if="isNewItem" v-model="newItem.unit_weight_kg" label="Unit Weight" size="small" units="kg"/>
                        <big-stepper v-else v-model="scannedItem.unit_weight_kg" label="Unit Weight" size="small" units="kg" />
                    </ion-item>
                    <ion-item lines="none">
                        <big-stepper v-if="isNewItem" v-model="newItem.case_weight_kg" label="Case Weight" size="small" units="kg"/>
                        <big-stepper v-else v-model="scannedItem.case_weight_kg" label="Case Weight" size="small" units="kg" />
                    </ion-item>
                    <ion-item lines="none">
                        <big-stepper v-model="boxesLikeThis" label="Boxes like this" size="small" />
                    </ion-item>
                    <ion-item lines="none">
                        <big-stepper v-model="totalQuantity" label="Total Items" size="small"/>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label>
                            <h2>Temporary Location</h2>
                            <p v-show="!hasSelectedLocation">No location set</p>
                            <p v-show="hasSelectedLocation">{{ location.code }}</p>
                        </ion-label>
                        <ion-button color="primary" size="medium" @click="pickTemporaryLocation()">
                            <ion-icon slot="icon-only" :icon="listOutline"/>
                        </ion-button>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label>B-Stock?</ion-label>
                        <ion-checkbox v-model="bStock"></ion-checkbox>
                    </ion-item>
                </section>
            </ion-list>
            <ion-row>
                <ion-col v-if="isNewItem || hasScannedItem">
                    <ion-button expand="full" color="secondary" @click="camera()">
                        <span v-if="!(imageBlob && imageBlob.length > 0)">Add Photo</span>
                        <span v-else>Retake Photo</span>
                    </ion-button>
                </ion-col>
                <ion-col>
                    <ion-button expand="full" color="success" @click="save()" :disabled="requiresInput || saving">Goods In</ion-button>
                </ion-col>
            </ion-row>
        </ion-content>
    </ion-page>

</template>

<script>
import StandardHeader from "@/components/StandardHeader";
import _ from 'lodash';
import {
    IonButton,
    IonCheckbox,
    IonContent, IonIcon,
    IonItem,
    IonSelect,
    IonSelectOption,
    IonInput,
    IonLabel,
    IonList,
    IonPage,
    IonRow,
    IonCol, alertController, pickerController, modalController
} from "@ionic/vue";
import {checkmarkCircle, search, barcode, listOutline, cameraOutline} from 'ionicons/icons';
import BigStepper from "@/components/BigStepper";
import {Capacitor} from "@capacitor/core";
import ItemSearchModalHelper from "@/services/ItemSearchModalHelper";
import ProductCardModal from "@/components/Modals/ProductCardModal";
import EventBus from "@/EventBus";
import {map} from "lodash";
import CameraModal from "@/views/modules/warehouse/receive/CameraModal";
export default {
    name: "GoodsIn",
    inject: ['$http', '$toast', '$validationAlert', '$scanner'],
    components: {
        ProductCardModal,
        BigStepper,
        IonCheckbox,
        StandardHeader,
        IonSelect, IonSelectOption, IonInput,
        IonContent, IonItem, IonLabel, IonList, IonPage, IonIcon, IonButton, IonRow, IonCol
    },
    computed: {
        hasSelectedLocation() {
            return this.location.id > 0;
        },
        payload() {
            const payload = {
                item: {...this.newItem},
                supplier: this.supplier
            };
            if (this.hasScannedItem) {
                payload.item = {...this.scannedItem};
            }
            payload.image = this.imageBlob;
            payload.bStock = this.bStock;
            payload.location = {...this.location};
            payload.quantity = this.totalQuantity;
            return payload;
        },
        caseQty() {
            const qty = this.hasScannedItem?this.scannedItem.case_qty:this.newItem.case_qty;
            return 1 * qty;
        },
        innerQty() {
            const qty = this.hasScannedItem?this.scannedItem.inner_qty:this.newItem.inner_qty;
            return 1 * qty;
        },
        requiresInput() {
            return !this.isNewItem && !this.hasScannedItem;
        },
        hasScannedItem() {
            return !this.isNewItem && this.scannedItem && this.scannedItem.id > 0;
        }
    },
    watch: {
        boxesLikeThis(newVal) {
            this.totalQuantity = newVal * this.caseQty;
        },
    },
    methods: {
        camera() {
            modalController.create({
                component: CameraModal
            }).then(m => {
                m.present();
                m.onDidDismiss().then(response => {
                    this.imageBlob = response.data;
                });
            });
        },
        async pickTemporaryLocation() {
            const picker = await pickerController.create({
                buttons: [{text: 'Cancel', role: 'cancel'}, {text: 'Confirm'}],
                columns: [{
                    name: 'location',
                    options: map(this.locations, location => {
                        return {
                            value: location,
                            text: location.code
                        }
                    })
                }]
            });
            await picker.present();
            picker.onDidDismiss().then(value => {
                this.location = value.data.location.value;
            });
        },
        save() {
            this.saving = true;
            this.$http.post('/api/goods-in/receive', this.payload).then(() => {
                EventBus().emitter.emit('loading', true);
                this.reset();
                this.isNewItem = false;
                this.$toast.success("Goods In Received");
            }).catch(error => {
                this.$validationAlert(error);
            }).finally(() => {
                this.saving = false;
                EventBus().emitter.emit('loading', false);
            });
        },
        setNew(event) {
            this.isNewItem = event;
            this.reset();
        },
        reset() {
            this.imageBlob = null;
            this.scannedItem = {};
            this.newItem = {};
            this.quantity = 0;
            this.boxesLikeThis = 0;
        },
        ionViewDidEnter() {
            if (this.suppliers.length < 1) {
                this.$http.get('/api/suppliers', {params: {order_by: 'code'}})
                    .then(response => {
                        this.suppliers = response.data.items;
                    }).catch(error => {
                        this.$validationAlert(error);
                    });
            }
            if (this.locations.length < 1) {
                this.$http.get('/api/locations', {params: {local_only: true, all: true, search:'is_temporary:1', order_by: 'code'}})
                    .then(response => {
                        this.locations = response.data.items;
                    }).catch(error => {
                    this.$validationAlert(error);
                });
            }
        },
        async openItemScanner() {
            if (Capacitor.platform === 'web') {
                const alert = await alertController.create({
                    header: 'Enter Item #ID',
                    inputs: [{
                        type: 'number',
                        name: 'item_id'
                    }],
                    buttons: ['Ok']
                });
                alert.onDidDismiss().then(input => {
                    const id = input.data.values.item_id;
                    this.$http.get(`/api/items/${id}`, {params: {include: 'skus,locations,image_urls,mpns'}})
                        .then(response => {
                            this.isNewItem = false;
                            this.newItem = {};
                            this.scannedItem = response.data;
                            // copied and pasted from the manual search version:
                            // find the first supplier barcode mpn and then tack it
                            // onto the scanned item barcode value .. just so it shows
                            const mpn = _.find(this.scannedItem.mpns, ['type', 'supplier_bc']);
                            this.scannedItem.barcode = mpn?.mpn;
                        });
                });
                alert.present();
                return;
            }
            this.$scanner.search().then(result => {
                this.scannedItem = result;
                this.isNewItem = false;
                this.newItem = {};

                // copied and pasted from the manual search version:
                // find the first supplier barcode mpn and then tack it
                // onto the scanned item barcode value .. just so it shows
                const mpn = _.find(this.scannedItem.mpns, ['type', 'supplier_bc']);
                console.log(mpn);
                this.scannedItem.barcode = mpn?.mpn;
            }).catch(error => {
                this.$toast.danger(error);
            });
        },
        openItemPicker() {
            ItemSearchModalHelper.open('skus,locations,image_urls,mpns').then(item => {
                if (! (item.data && item.data.id)) {
                    return;
                }
                this.scannedItem = item.data;
                const mpn = _.find(this.scannedItem.mpns, ['type', 'supplier_bc']);
                this.scannedItem.barcode = mpn?.mpn;
            });
        }
    },
    data() {
        return {
            imageBlob: null,
            bStock: false,
            saving: false,
            isNewItem: false,
            newItem: {},
            location: {},
            boxesLikeThis: 0,
            totalQuantity: 0,
            scannedItem: {},
            suppliers: [],
            locations: []
        }
    },
    setup() {
        return {
            checkmarkCircle, search, barcode, listOutline, cameraOutline
        }
    }

}
</script>

<style scoped>
    .masked {
        display:none;
    }
</style>
